/* eslint-disable import/order */
import { boardRelayResource } from '@jira/router-resources__board-resource/src/conditionalBoardTmpMatureExampleGupsResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const conditionalBoardRelayResource: RouteResource<any> = resourceWithCondition(
	() => fg('critical_board_query_with_relay'),
	boardRelayResource,
);
